import gql from 'graphql-tag';

/**
 * @param orderId optional order ID
 */
export const CTGLoyaltyDeductPoints = gql`
  mutation ctgLoyaltyDeductPoints(
    $loyaltyId: String!
    $loyaltyUserCognitoId: String!
    $points: Int!
    $reason: String!
    $orderId: String
    $comments: String
  ) {
    ctgLoyaltyDeductPoints(
      loyaltyId: $loyaltyId
      loyaltyUserCognitoId: $loyaltyUserCognitoId
      points: $points
      reason: $reason
      orderId: $orderId
      comments: $comments
    )
  }
`;
